import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { getScoreLetterFromScoreVenueDates } from '@/domain/impact-calculate/utils/get-score-letter-from-score-venue-dates.ts';
import {
  CalculateVenueEss,
  EMPTY_CALCULATE_VENUE_ESS,
} from '@/domain/impact-calculate-venue/entities/calculate-venue-ess.entity.ts';

import { CalculateVenueEssDto } from './dto.type';

export class CalculateVenueEssMapper {
  static dtoToEntity(dto: CalculateVenueEssDto): CalculateVenueEss {
    const globalScore = Number.parseFloat(dto.score.toString());
    const globalMaxScore = Number.parseFloat(dto.maxScore.toString());
    const globalScoreLetter = getScoreLetterFromScore(
      globalScore / globalMaxScore,
    );
    return {
      global: {
        score: globalScore,
        maxScore: globalMaxScore,
        scoreLetter: globalScoreLetter,
      },
      structure: dto.structure
        ? {
            score: dto.structure.score,
            maxScore: dto.structure.maxScore,
            scoreLetter: getScoreLetterFromScore(
              dto.structure.score / dto.structure.maxScore,
            ),
            topics: {
              PARITY_EQUALITY: {
                score: dto.structure.topics.PARITY_EQUALITY.score,
                maxScore: dto.structure.topics.PARITY_EQUALITY.maxScore,
                sections: {
                  ARTISTIC_TEAM: {
                    score:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .ARTISTIC_TEAM.score,
                    maxScore:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .ARTISTIC_TEAM.maxScore,
                  },
                  PERMANENT_OPERATIONAL_TEAM: {
                    score:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .PERMANENT_OPERATIONAL_TEAM.score,
                    maxScore:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .PERMANENT_OPERATIONAL_TEAM.maxScore,
                  },
                  OCCASIONAL_OPERATIONAL_TEAM: {
                    score:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .OCCASIONAL_OPERATIONAL_TEAM.score,
                    maxScore:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .OCCASIONAL_OPERATIONAL_TEAM.maxScore,
                  },
                  TRANSPARENCY_MANAGEMENT: {
                    score:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .TRANSPARENCY_MANAGEMENT.score,
                    maxScore:
                      dto.structure.topics.PARITY_EQUALITY.sections
                        .TRANSPARENCY_MANAGEMENT.maxScore,
                  },
                },
              },
              ACCESSIBILITY_SOCIAL_DIALOGUE: {
                score: dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.score,
                maxScore:
                  dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.maxScore,
                sections: {
                  ACCESSIBILITY: {
                    score:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.ACCESSIBILITY.score,
                    maxScore:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.ACCESSIBILITY.maxScore,
                  },
                  RISK_PREVENTION: {
                    score:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.RISK_PREVENTION.score,
                    maxScore:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.RISK_PREVENTION.maxScore,
                  },
                  COMMUNICATION: {
                    score:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.COMMUNICATION.score,
                    maxScore:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.COMMUNICATION.maxScore,
                  },
                  TEAM_MANAGEMENT: {
                    score:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.TEAM_MANAGEMENT.score,
                    maxScore:
                      dto.structure.topics.ACCESSIBILITY_SOCIAL_DIALOGUE
                        .sections.TEAM_MANAGEMENT.maxScore,
                  },
                },
              },
              LOCAL_IMPACT_RSE_ENGAGEMENT: {
                score: dto.structure.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.score,
                maxScore:
                  dto.structure.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.maxScore,
                sections: {
                  LOCALITY_EMPLOYMENT_PARTNERS: {
                    score:
                      dto.structure.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                        .LOCALITY_EMPLOYMENT_PARTNERS.score,
                    maxScore:
                      dto.structure.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                        .LOCALITY_EMPLOYMENT_PARTNERS.maxScore,
                  },
                  ECONOMIC_SOCIAL_IMPACT: {
                    score:
                      dto.structure.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                        .ECONOMIC_SOCIAL_IMPACT.score,
                    maxScore:
                      dto.structure.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                        .ECONOMIC_SOCIAL_IMPACT.maxScore,
                  },
                },
              },
            },
          }
        : EMPTY_CALCULATE_VENUE_ESS.structure,
      dates: dto.events
        ? {
            score: dto.events.score || 0,
            maxScore: dto.events.maxScore || 0,
            scoreLetter: dto.events?.score
              ? getScoreLetterFromScoreVenueDates(dto.events.score)
              : '-',
          }
        : EMPTY_CALCULATE_VENUE_ESS.dates,
    };
  }
}
